import { Box, Button, Typography } from '@compass/core';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';

interface TabEmptyStateProps {
    onAddCardsClick: () => void;
}

export const TabEmptyState = ({ onAddCardsClick }: TabEmptyStateProps) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 10,
            px: 3,
            textAlign: 'center',
            borderRadius: 2,
            border: '1px dashed',
            borderColor: 'divider',
            backgroundColor: 'action.hover',
        }}
    >
        <DashboardCustomizeOutlinedIcon
            sx={{ fontSize: 56, color: 'text.disabled', mb: 2 }}
        />
        <Typography variant="h6" sx={{ mb: 1 }}>
            This tab is empty
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 320 }}>
            Add cards to customize this workspace with the information that matters most to you.
        </Typography>
        <Button variant="contained" onClick={onAddCardsClick}>
            Add Cards to this Tab
        </Button>
    </Box>
);